import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Customer } from '../../models/Customer';
import { selectEmployeesOfCustomer, selectCustomer } from '../../state/customer/customer.selector';
import { getCustomerEmployees, getCurrentCustomer } from '../../state/customer/customer.actions';
import { PageHeaderComponent, HeaderAction } from '../page-header/page-header.component';
import { SendInvitationDialogComponent } from './send-invitation-dialog/send-invitation-dialog.component';
import CustomerService from '../../services/CustomerService';

@Component({
  selector: 'app-manage-employees',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTableModule, MatDialogModule, MatSnackBarModule, PageHeaderComponent],
  templateUrl: './manage-employees.component.html',
  styleUrl: './manage-employees.component.css'
})
export class ManageEmployeesComponent implements OnInit {
  employees$: Observable<Customer[]>;
  childCustomers$!: Observable<any[]>;  // Initialized in ngOnInit
  currentCustomer$: Observable<Customer | null>;
  headerActions: HeaderAction[] = [];

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private customerService: CustomerService,
    private snackBar: MatSnackBar
  ) {
    this.employees$ = this.store.select(selectEmployeesOfCustomer).pipe(
      map(employees => employees ?? [])
    );
    this.currentCustomer$ = this.store.select(selectCustomer);

    this.headerActions = [
      {
        label: 'Einladung senden',
        icon: 'email',
        onClick: () => this.openSendInvitationDialog(),
        variant: 'primary'
      }
    ];
  }

  ngOnInit(): void {
    this.store.dispatch(getCurrentCustomer());
    this.store.dispatch(getCustomerEmployees());
    this.loadChildCustomers();
  }

  loadChildCustomers(): void {
    this.childCustomers$ = this.customerService.getMyChildCustomers();
  }

  activateChild(childId: number): void {
    this.customerService.activateChildCustomer(childId).subscribe({
      next: () => {
        this.snackBar.open('Kind-Kunde erfolgreich aktiviert', 'OK', { duration: 3000 });
        this.loadChildCustomers();
      },
      error: (err) => {
        console.error('Failed to activate child', err);
        this.snackBar.open('Fehler beim Aktivieren', 'Schließen', { duration: 5000 });
      }
    });
  }

  deactivateChild(childId: number): void {
    this.customerService.deactivateChildCustomer(childId).subscribe({
      next: () => {
        this.snackBar.open('Kind-Kunde erfolgreich deaktiviert', 'OK', { duration: 3000 });
        this.loadChildCustomers();
      },
      error: (err) => {
        console.error('Failed to deactivate child', err);
        this.snackBar.open('Fehler beim Deaktivieren', 'Schließen', { duration: 5000 });
      }
    });
  }

  openSendInvitationDialog(): void {
    this.currentCustomer$.subscribe(customer => {
      if (customer) {
        const customerNo = customer.reflexCustomerNo || customer.customerReflexId;
        const dialogRef = this.dialog.open(SendInvitationDialogComponent, {
          width: '600px',
          data: { customerNo }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            console.log('Invitation sent successfully');
          }
        });
      }
    }).unsubscribe();
  }
}
